import { FalloDeVisor } from "./errores.js";
import type { Enlace } from "./enlace.js";

export interface ModeloFirmado {
  /** URL prefirmada, valida por pocos minutos y solo para GET. */
  url: string;
  /** Unix seconds en que caduca la URL prefirmada. */
  expiresAt: number;
  /** Etiqueta del proyecto. Ausente en links anteriores al inventario. */
  proyecto?: string;
  /** Unix seconds de publicacion. Ausente en links anteriores al inventario. */
  publicadoEn?: number;
}

/**
 * `GET /api/model/:id` con el token en `Authorization: Bearer`.
 *
 * El token va en la cabecera y no en la URL para que no quede en logs del servidor.
 * Los codigos son el contrato de la Fase 3; en dev los sirve el plugin de Vite.
 */
export async function pedirModelo(enlace: Enlace): Promise<ModeloFirmado> {
  let respuesta: Response;
  try {
    respuesta = await fetch(`/api/model/${encodeURIComponent(enlace.id)}`, {
      headers: { Authorization: `Bearer ${enlace.token}` },
      cache: "no-store",
    });
  } catch (causa) {
    throw new FalloDeVisor("fallo_de_red", causa);
  }

  if (respuesta.status === 401) throw new FalloDeVisor("link_invalido");
  if (respuesta.status === 403) throw new FalloDeVisor("link_expirado");
  if (respuesta.status === 404) throw new FalloDeVisor("modelo_no_encontrado");
  if (!respuesta.ok) throw new FalloDeVisor("fallo_de_red");

  let cuerpo: unknown;
  try {
    cuerpo = await respuesta.json();
  } catch (causa) {
    throw new FalloDeVisor("fallo_de_red", causa);
  }

  if (
    typeof cuerpo !== "object" ||
    cuerpo === null ||
    typeof (cuerpo as ModeloFirmado).url !== "string"
  ) {
    throw new FalloDeVisor("fallo_de_red");
  }

  const datos = cuerpo as ModeloFirmado;
  return {
    url: datos.url,
    expiresAt: Number(datos.expiresAt) || 0,
    // Opcionales: un link viejo sin registro simplemente no trae contexto.
    ...(typeof datos.proyecto === "string" && datos.proyecto !== ""
      ? { proyecto: datos.proyecto }
      : {}),
    ...(typeof datos.publicadoEn === "number" && Number.isFinite(datos.publicadoEn)
      ? { publicadoEn: datos.publicadoEn }
      : {}),
  };
}
